<template>
  <div class="has-text-left">

    <div class="field">
      <component
        v-if="APM"
        :is="methods[APM]"
        @request="sendMulixWDRequest"
      ></component>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import config from '../../../config'
import wdMethods from './mulix-wd-methods'

export default {
  props: ['apm'],
  data() {
    return {
      amount: 0,
      currencySymbols: config.currencies,
      methods: wdMethods,
      apmMap: {
        mulixVisa: 'VISA',
        mulixPayretailers: 'PAYRETAILERS',
      },
      payment_data: null,
    }
  },
  // watch: {},
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
    APM() {
      let method = 'mulixVisa'
      if (this.apm) {
        method = this.apm
        let parts = method.split('-')
        parts.forEach((v, i, a) => {
          if (i > 0) {
            a[i] = v.tCapitalizeFirstLetter()
          }
        })
        method = parts.join('')
      }

      return method
    },
  },
  mounted() {
    this.$bus.$on('request', this.sendMulixWDRequest)
    /*
    if (typeof this.User.info.country_code !== 'undefined' && this.User.info.country_code !== '') {
      this.country = this.User.info.country_code
    }
    */
  },
  beforeDestroy() {
    this.$bus.$off('request', this.sendMulixWDRequest)
  },
  methods: {
    sendMulixWDRequest(data = null) {
      if (data == null) {
        this.$toasted.error('Unable to send request: No payment data')
        return
      }
      this.payment_data = data
      this.withdraw()
    },
    withdraw() {
      let extraInfo = JSON.stringify(this.payment_data)

      let psp = 'mulix'
      let method = this.APM ? this.apmMap[this.APM] : 'VISA'
      if (this.APM == 'mulixPayretailers') {
        psp = this.apmMap[this.APM]
        method = this.payment_data.pixKey ? 'PIX' : 'BankWire'
      }

      let withdrawalArgs = {
        userID: this.$store.state.user.info.ID,
        amount: String(this.payment_data.amount),
        psp: psp,
        method: method,
        // env: 'production',
        extraInfo: extraInfo,
      }

      this.$bus.$emit(
        'RequestWithdraw',
        '/finance/withdraw',
        withdrawalArgs,
        response => {
          this['logoLoader/set'](false)
          // console.log(response)

          if (response.data.success) {
            this.payment.URL = response.data.redirectURL
            this.payment.ID = response.data.transactionID
          } else {
            this.$toasted.error('There was an error contacting the payment provider. Please try again.')
            this.payment.error = true
          }
        },
        error => {
          console.log(error)
          this.payment.error = true
          if (error.response.data.meta) {
            let meta = error.response.data.meta
            if (meta[config.API.translationKeyName]) {
              this['errorModal/set']({ active: true, text: this.$t(meta[config.API.translationKeyName]).tTitle() })
            }
          }
        }
      )
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '../../../assets/css/variables';

label {
  text-align: left;
}

.mulix-frame {
  height: 450px;

  max-width: 600px;
  width: 600px;

  @media only screen and (max-width: $tablet - 1px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// Mulix.vue?9f53be8c